
import { defineComponent, onMounted } from 'vue';
import { AppTable, AppCard } from '@/components';
import { useTournamentCycle } from '@/modules/tournament/cycle/model/list';
import { ROUTE_NAME_TOURNAMENT } from '@/modules/tournament/router';
import { TableColumn, TableColumnType } from '@/components/table/types';

export default defineComponent({
    name: ROUTE_NAME_TOURNAMENT.CYCLE,
    components: { AppTable, AppCard },
    setup() {
        const { list, total, query, fetchList } = useTournamentCycle();

        const columns: TableColumn[] = [
            { type: TableColumnType.Index, label: '#' },
            {
                type: TableColumnType.RouterLink,
                label: 'Leaderboard',
                key: 'leaderboardName',
                to: (row: any) => ({
                    name: ROUTE_NAME_TOURNAMENT.LEADERBOARD.DETAIL,
                    params: { id: row.tournamentLeaderboardId }
                })
            },
            { type: TableColumnType.Text, label: 'Cycle', key: 'id' },
            { type: TableColumnType.DateTime, label: 'Start Time', key: 'startTime' },
            { type: TableColumnType.DateTime, label: 'End Time', key: 'endTime' },
            { type: TableColumnType.Option, label: 'Status', key: 'status', options: statusList }
        ];

        onMounted(fetchList);

        return { columns, list, total, query, fetchList, ROUTE_NAME_TOURNAMENT };
    }
});

const statusList = [
    { label: 'None', value: 0, background: 'secondary' },
    { label: 'Started', value: 1, background: 'success' },
    { label: 'Ended', value: 2, background: 'info' },
    { label: 'Disabled', value: 3, background: 'secondary' }
];
